import AccountService from "./../shared/services/accountService";

const REQUEST_REGISTRATION_USER = "REQUEST_REGISTRATION_USER";
const RESPONSE_REGISTRATION_USER = "RESPONSE_REGISTRATION_USER";
const REQUEST_REGISTRATION_USER_FAILURE = "REQUEST_REGISTRATION_USER_FAILURE";

const requestRegistrationUserAction = () => {
  return {
    type: REQUEST_REGISTRATION_USER,
  };
};

const responseRegistrationUserAction = (data) => {
  return {
    type: RESPONSE_REGISTRATION_USER,
    data,
  };
};

const requestRegistrationUserfailureAction = (errors) => {
  return {
    type: REQUEST_REGISTRATION_USER_FAILURE,
    errors,
  };
};

const getRegistration = (data) => {
  return (dispatch) => {
    dispatch(requestRegistrationUserAction());

    AccountService.getRegistrationUser(data)
      .then((result) => {
        dispatch(responseRegistrationUserAction(result.data));
      })
      .catch((error) => {
        dispatch(requestRegistrationUserfailureAction(error.response));
      });
  };
};

const READY_CHANGE_STORE_REGISTRATION = "READY_CHANGE_STORE_REGISTRATION";
const READY_CLEAR_STORE_REGISTRATION = "READY_CLEAR_STORE_REGISTRATION";

const responseChangeStoreRegistrationAction = (name, value) => {
  return {
    type: READY_CHANGE_STORE_REGISTRATION,
    payload: { name, value },
  };
};

const handleChangeStoreRegistration = (name, value) => {
  return (dispatch) => {
    dispatch(responseChangeStoreRegistrationAction(name, value));
  };
};

const responseClearStoreSingInAction = () => {
  return {
    type: READY_CLEAR_STORE_REGISTRATION,
  };
};

const handleClearStoreSingIn = () => {
  return (dispatch) => {
    dispatch(responseClearStoreSingInAction());
  };
};

const REQUEST_REGISTRATION = "REQUEST_REGISTRATION";
const RESPONSE_REGISTRATION = "RESPONSE_REGISTRATION";
const REQUEST_REGISTRATION_FAILURE = "REQUEST_REGISTRATION_FAILURE";

const requestRegistrationAction = () => {
  return {
    type: REQUEST_REGISTRATION,
  };
};

const responseRegistrationAction = (data) => {
  return {
    type: RESPONSE_REGISTRATION,
    data,
  };
};

const requestRegistrationFailureAction = (errors) => {
  return {
    type: REQUEST_REGISTRATION_FAILURE,
    errors,
  };
};

const registration = (data) => {
  return (dispatch) => {
    dispatch(requestRegistrationAction());

    AccountService.registration(data)
      .then((result) => {
        dispatch(responseRegistrationAction());
      })
      .catch((error) => {
        dispatch(requestRegistrationFailureAction(error.response));
      });
  };
};

export {
  REQUEST_REGISTRATION_USER,
  RESPONSE_REGISTRATION_USER,
  REQUEST_REGISTRATION_USER_FAILURE,
  getRegistration,
  READY_CHANGE_STORE_REGISTRATION,
  handleChangeStoreRegistration,
  READY_CLEAR_STORE_REGISTRATION,
  handleClearStoreSingIn,
  REQUEST_REGISTRATION,
  RESPONSE_REGISTRATION,
  REQUEST_REGISTRATION_FAILURE,
  registration,
};
